<template>
  <case-error-notification @close-clicked="deselectUnavailableItemTypes">
    <div
      :class="{ 'd-flex': unavailableItemTypes.length === 1 }"
      class="text-start px-2 py-1 px-md-4 py-md-2">
      <div class="images">
        <div
          v-for="item in unavailableItemTypes"
          :key="item.id"
          @click="navigateToDetailPage(styleColorsMap[item.styleColor])">
          <my-case-item-image
            class="me-2"
            :style-color="styleColorsMap[item.styleColor]"/>
        </div>
      </div>
      <div><b>Bummer! </b>Another member grabbed {{ unavailableItemTypes.length > 1 ? 'these styles' : 'this style' }}.</div>
    </div>
  </case-error-notification>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CaseErrorNotification from './CaseErrorNotification'
import MyCaseItemImage from '../common/MyCaseItemImage'
import { useFlyouts } from '@/composables/flyouts'
import useScreenSize from '@shared/composables/screenSize.js'


export default {
  components: {
    CaseErrorNotification,
    MyCaseItemImage,
  },
  setup () {
    const flyouts = useFlyouts()
    const { isTabletOrSmaller } = useScreenSize()
    return {
      flyouts,
      isTabletOrSmaller
    }
  },
  computed: {
    ...mapState('closet', [
      'styleColorsMap',
      'unavailableItemTypes'
    ])
  },
  beforeUnmount () {
    this.deselectUnavailableItemTypes()
  },
  methods: {
    ...mapActions('closet', [
      'deselectUnavailableItemTypes'
    ]),
    navigateToDetailPage(item) {
      this.flyouts.openClosetDetailFlyout(item, null, null, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.images {
  display: flex;
  max-width: 112px;
  flex-shrink: 0;
  margin-right: 4px;
  margin-bottom: 8px;
}
</style>
